var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switcher-field",class:{ 'isActive': _vm.checked }},[_c('input',{attrs:{"type":"checkbox"},domProps:{"value":_vm.checked},on:{"input":_vm.modeChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }